module.exports = "https://portperrypedals.ca/_res/img/tallboy.b4131b9.avif";